import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { Dialog } from "../BaseComponents/Dialog";
import { isSukiAdmin } from "../../helpers/roles";
import { isValidEmail, isValidName } from "../../util";
import { ALLOWED_ADMIN_ROLES, ALLOWED_SUKI_ADMIN_ROLES, ROLES, ROLES_MASK } from "../../util/constants";

const human = require("humanparser");

export const UserModal = ({ onClose, open, createOrUpdateUser, selectedUser, title }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState(ROLES.ENTERPRISE_ADMIN);
  const [disabled, setDisabled] = useState(true);

  const [error, setError] = useState({ name: "", email: "" });

  useEffect(() => {
    if (selectedUser) {
      setFullName(selectedUser.name);
      setRole(selectedUser.role);
      setEmail(selectedUser.email);
    } else {
      resetFields();
    }
  }, [selectedUser]);

  useEffect(() => {
    if (fullName && error.name) {
      setError({ ...error, name: "" });
    }

    if (email && error.email) {
      setError({ ...error, email: "" });
    }
  }, [fullName, error, email]);

  useEffect(() => {
    if (selectedUser) {
      const disabled = selectedUser.name === fullName && selectedUser.role === role && selectedUser.email === email;
      setDisabled(disabled);
    }
  }, [fullName, email, selectedUser, role]);

  const createOrUpdateUserHandler = () => {
    const { firstName, lastName, middleName } = human.parseName(fullName);

    if (!isValidName(firstName) || !isValidName(lastName)) {
      setError({ ...error, name: "Must be a valid name" });
      return;
    }

    if (!isValidEmail(email)) {
      setError({ ...error, email: "Must be a valid email" });
      return;
    }

    createOrUpdateUser({
      ...selectedUser,
      firstName,
      middleName,
      lastName,
      email,
      role
    });

    onClose();
    resetFields();
  };

  const resetFields = () => {
    setFullName("");
    setEmail("");
    setRole(ROLES.ENTERPRISE_ADMIN);
  };

  const createButtonProps = {
    name: selectedUser ? "Save" : "Create",
    onAction: createOrUpdateUserHandler,
    disabled: selectedUser ? disabled : !fullName || !email
  };

  const onCancel = () => {
    onClose();
    resetFields();
  };

  return (
    <Dialog isOpened={open} onCancel={onCancel} title={title} buttonProps={createButtonProps}>
      <TextField
        error={!!error.name}
        variant="outlined"
        autoFocus
        margin="dense"
        id="name"
        label="Full Name"
        type="text"
        fullWidth
        required
        onChange={(e) => setFullName(e.target.value)}
        value={fullName}
        helperText={error.name}
      />
      <TextField
        error={!!error.email}
        variant="outlined"
        margin="dense"
        id="name"
        label="Email"
        type="text"
        disabled={!!selectedUser}
        fullWidth
        required
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        helperText={error.email}
      />
      <FormControl variant="outlined" fullWidth margin="dense">
        <InputLabel id="demo-simple-select-outlined-label">Role</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          defaultValue={ROLES.ENTERPRISE_ADMIN}
          value={role}
          onChange={(e) => setRole(e.target.value)}
          label="Role"
          required
        >
          {(isSukiAdmin() ? ALLOWED_SUKI_ADMIN_ROLES : ALLOWED_ADMIN_ROLES).map((role, index) => (
            <MenuItem key={`${role}_${index}`} value={role}>
              <em>{ROLES_MASK[role]}</em>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Dialog>
  );
};

export default UserModal;
